import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProjectDetails.css';
import Aos from 'aos';
import 'aos/dist/aos.css';

const ProjectDetails = ({project}) => {

    useEffect( () => {
        Aos.init({duration: 1500})
    }, [])
    const {name, description, websiteImg, websiteURL, _id} = project;

    return (
        <div data-aos='flip-left' className='project-details shadow-md hover:shadow-2xl rounded-lg p-3'>
            
            <img className='my-2' src={websiteImg} alt="" />
            <h2 className='my-2 text-2xl font-semibold text-red-600'>{name}</h2>
            <p className='my-2 text-gray-400'>{description}</p>
            <p><Link to={websiteURL} target={'_blank'}><button className='btn btn-sm btn-outline w-full'>Click Here To Live Preview</button></Link></p>

        </div>
    );
};

export default ProjectDetails;